<template>
  <section class="record-layout">
    <nav class="record-tabs" aria-label="订单与发票">
      <router-link
        v-for="item in tabItems"
        :key="item.name"
        :to="{ name: item.name }"
        class="record-tab"
        :class="{ active: route.name === item.name }"
      >
        <span class="record-tab-label">{{ item.label }}</span>
        <span class="record-tab-indicator" aria-hidden="true" />
      </router-link>
    </nav>

    <router-view />
  </section>
</template>

<script setup lang="ts">
  import { useRoute } from 'vue-router';

  const route = useRoute();

  const tabItems = [
    { name: 'orders-history', label: '历史订单' },
    { name: 'orders-invoice', label: '发票历史' }
  ];
</script>

<style scoped>
  .record-layout {
    --orders-body-bottom-space: 40px;

    height: calc(100% + var(--orders-body-bottom-space));
    margin-bottom: calc(var(--orders-body-bottom-space) * -1);
    min-height: 0;
    display: flex;
    flex-direction: column;
    gap: 24px;
    padding-top: 5px;
    box-sizing: border-box;
  }

  .record-tabs {
    flex-shrink: 0;
    display: flex;
    align-items: flex-start;
    gap: 20px;
  }

  .record-tab {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    min-width: 56px;
    color: #6e6a7c;
    font-size: 14px;
    line-height: 22px;
    text-decoration: none;
    transition: color 0.15s;
  }

  .record-tab:hover,
  .record-tab.active {
    color: #160211;
  }

  .record-tab-label {
    line-height: 14px;
  }

  .record-tab-indicator {
    width: 20px;
    height: 2px;
    border-radius: 2px;
    background: #6033e1;
    opacity: 0;
    transition: opacity 0.15s;
  }

  .record-tab.active .record-tab-indicator {
    opacity: 1;
  }

  @media (max-width: 767px) {
    .record-layout {
      --orders-body-bottom-space: 0px;

      gap: 0;
      padding-top: 0;
    }

    .record-tabs {
      height: 32px;
      gap: 20px;
    }
  }
</style>
